import React from 'react';
import {
	Card as MuiCard,
	CardActionArea,
	CardHeader,
	IconButton,
	Typography,
	CircularProgress,
	Stack,
	capitalize,
} from '@mui/material';
import Icon from 'presentation/icons';
import {CardProps} from './types';
import {useCard} from './useCard';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';

export function Card({item, isLoading, handleContextMenuOpen, handleCardClick}: CardProps) {
	const {
		beneficiary: {idadeC},
	} = useAccountDataStore(state => state.accountData);

	const {colors, getRightIcon, handleCardKeyDown, formattedAddress} = useCard({
		item,
		handleCardClick,
	});

	const isUnderage = idadeC < 18;

	return (
		<MuiCard elevation={0} sx={{height: '100%'}}>
			<CardActionArea
				disabled={isLoading}
				sx={{height: '100%', cursor: 'default'}}
				component="div"
				tabIndex={0}
				onKeyDown={event => handleCardKeyDown(event, item)}>
				<Stack gap={1}>
					<CardHeader
						avatar={
							isLoading ? (
								<CircularProgress size={24} />
							) : (
								<Icon
									name={getRightIcon(item.address.nmLocal)}
									color={colors.brand.primary.blue}
								/>
							)
						}
						sx={{'& .MuiCardHeader-avatar': {alignSelf: 'start', mr: 1.5}}}
						action={
							isUnderage ? null : (
								<IconButton
									size="small"
									sx={{rotate: '90deg'}}
									onClick={event => handleContextMenuOpen(event, item)}>
									<Icon
										name="more-horiz-filled"
										color={colors.brand.primary.blue}
									/>
								</IconButton>
							)
						}
						title={
							<Typography color="text.primary" variant="subheader">
								{capitalize(item.address.nmLocal.toLowerCase())}
							</Typography>
						}
						subheader={
							<Typography variant="body2" color="text.secondary">
								{formattedAddress}
							</Typography>
						}
					/>
				</Stack>
			</CardActionArea>
		</MuiCard>
	);
}
